export default __webpack_public_path__ + "static/media/bitcoin.ecb5d5b1.png";